import type { ToppingToPrint } from 'features/print-management/order-invoice-printing';

export function toppingSortedByParentId(toppings: ToppingToPrint[]) {
  const baseList = toppings.map((t): ToppingToPrint => ({ ...t }));
  baseList.forEach(topping => {
    const list = baseList.filter(t => t.parentID === topping.id);
    // Alternative using Arrays: src/features/print-management/order-invoice-printing/infra/orderToPrint.adapter.ts
    const listMap = new Map();
    list.forEach(t => {
      const value = listMap.get(t.name);
      if (value === undefined) listMap.set(t.name, [t]);
      else value.push(t);
    });
    topping.children = Array.from(listMap.values()).flat();
  });
  return baseList.filter(t => isNaN(t.parentID));
}
